import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const ImportMaterialList = Loadable(
  lazy(() => import("features/importMaterial/components/Page"))
);

const routes = {
  path: "importMaterial",
  children: [{ path: "", element: <ImportMaterialList /> }],
};

export default routes;
